export default __webpack_public_path__ + "static/media/need-help-footer.201ad127.svg";